import { Component } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { OperationService } from 'src/app/shared/service/operation/operation.service';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-listing-pta-pdc',
  standalone: false,
  templateUrl: './listing-pta-pdc.component.html',
  styleUrl: './listing-pta-pdc.component.scss'
})



export class ListingPtaPdcComponent  {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  accesData: any =[];
  pdcItems: any =[];

  modalRef: NgbModalRef | null = null;

  paginatedProjets = [];
  firstProjets: number = 0; // La page actuelle (commence à 0)
  rowsProjets: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  isLoadingPdc: boolean = false;
  searchTerm: string = '';
  filteredData: any[] = []; // Données filtrées

   paginatedProjetsPdc = [];
  firstProjetsPdc: number = 0; // La page actuelle (commence à 0)
  rowsProjetsPdc: number = 10; // Nombre d'éléments par page
  totalRecordsPdc: number = 0; 
  constructor(
      private modalService: NgbModal,
      private paramService:ParameterService,
      private operationService:OperationService,
      private localstorage:LocalStorageService,
      private confirmationService: ConfirmationService,
      private messageService: MessageService,
      private ngxService: NgxUiLoaderService,
      private authService: AuthService,
      private fetchService:FecthDataService

  ) { 
    this.fetchService.actionCreated$.subscribe(() => {
      this.fetchDataPta();
    });
  }

  ngOnInit(): void {
  }

  //recuperation des donnees de pta
  fetchDataPta() {
    this.isLoading = true;

    this.paramService.getPta().subscribe(
      (response: any) => {
        this.accesData = response.data;
        
        this.filteredData = [...this.accesData]; 
        this.totalRecords = this.filteredData.length;
        this.updatePaginatedProjets();
        this.fetchDataPdc();
        this.isLoading = false;
      },
      (error) => {
        ////console.log("une erreur est survenue", error);
        this.isLoading = false;
      }
    );
  }//end fetchDataPta

  onPageChangeProjets(event) {
    this.firstProjets = event.first ;
    this.rowsProjets = event.rows ;
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredData.slice(start, end);
  }

  //recuperation des donnees de pdc
  fetchDataPdc() {
    this.isLoadingPdc = true;

    this.paramService.getPdcItems().subscribe(
      (response: any) => {
        this.pdcItems = response.data;

        //console.log("this.accesData",this.accesData);
        
       // this.filteredData = [...this.accesData]; 
        this.totalRecordsPdc = this.pdcItems.length;
        this.updatePaginatedProjetsPcd();
        this.isLoadingPdc = false;
      },
      (error) => {
        ////console.log("une erreur est survenue", error);
        this.isLoadingPdc = false;
      }
    );
  }

  onPageChangeProjetPdcs(event) {
    this.firstProjetsPdc = event.first ;
    this.rowsProjetsPdc = event.rows ;
    this.updatePaginatedProjetsPcd();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjetsPcd() {
    const start = this.firstProjetsPdc;
    const end = start + this.rowsProjetsPdc;
    this.paginatedProjetsPdc = this.pdcItems.slice(start, end);
  }


  applyFilter(term: string) {
    this.searchTerm = term.trim().toLowerCase();

    if (this.searchTerm) {
      this.filteredData = this.accesData.filter(user =>
        user.name.toLowerCase().includes(this.searchTerm)
      );
    } else {
      // Réinitialiser les données filtrées si la recherche est vide
      this.filteredData = [...this.accesData];
    }

    this.totalRecords = this.filteredData.length;
    this.firstProjets = 0; // Revenir à la première page après le filtrage
    this.updatePaginatedProjets();
  }

  
   //methode de suppression
   confirmDeletionPta(ptaObject: any) {
    this.confirmationService.confirm({
        message: "Êtes-vous sûr de vouloir supprimer ce PTA?",
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Oui', 
        rejectLabel: 'Non', 
        accept: () => {
          this.ngxService.start();

          const requestData = {
            "annee": ptaObject.annee,
            "reference": ptaObject.reference
          }
            this.authService.deletePta(requestData).subscribe(
              (response:any)=>{
                this.ngxService.stop();
                ////console.log("la reponse du webserice",response);
                this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: response.message });
                this.fetchDataPta();
              },
              (error)=>{
                this.ngxService.stop();
                ////console.log("une erreur est survenu",error);
                this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });  
              },
            )
          },
        reject: () => {
            //this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
        }
    });
  }

    //Suppression de pdc
   confirmDeletionPdc(pdcObj: any) {

    this.confirmationService.confirm({
        message: "Êtes-vous sûr de vouloir supprimer ce PDC?",
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Oui', 
        rejectLabel: 'Non', 
        accept: () => {
          this.ngxService.start();

          const requestData = {
            "reference": pdcObj.reference
          }
          
            this.authService.deletePdc(requestData).subscribe(
              (response:any)=>{
                this.ngxService.stop();
                ////console.log("la reponse du webserice",response);
                this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: response.message });
                this.fetchDataPdc();
              },
              (error)=>{
                this.ngxService.stop();
                ////console.log("une erreur est survenu",error);
                this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });  
              },
            )
          },
        reject: () => {
            //this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
        }
    });
  }

}